export const POST_FEEDBACK = "POST_FEEDBACK";
export const POST_FEEDBACK_SUCCESS = "POST_FEEDBACK_SUCCESS";
export const POST_FEEDBACK_ERROR = "POST_FEEDBACK_ERROR";

export const GET_TICKETS = "GET_TICKETS";
export const GET_TICKETS_SUCCESS = "GET_TICKETS_SUCCESS";
export const GET_TICKETS_ERROR = "GET_TICKETS_ERROR";

export const GET_SINGLE_TICKET = "GET_SINGLE_TICKET";
export const GET_SINGLE_TICKET_SUCCESS = "GET_SINGLE_TICKET_SUCCESS";
export const GET_SINGLE_TICKET_ERROR = "GET_SINGLE_TICKET_ERROR";

export const GET_OPEN_TICKETS = "GET_OPEN_TICKETS";
export const GET_OPEN_TICKETS_SUCCESS = "GET_OPEN_TICKETS_SUCCESS";
export const GET_OPEN_TICKETS_ERROR = "GET_OPEN_TICKETS_ERROR";

export const GET_CLOSED_TICKETS = "GET_CLOSED_TICKETS";
export const GET_CLOSED_TICKETS_SUCCESS = "GET_CLOSED_TICKETS_SUCCESS";
export const GET_CLOSED_TICKETS_ERROR = "GET_CLOSED_TICKETS_ERROR";

export const POST_REPLY = "POST_REPLY";
export const POST_REPLY_SUCCESS = "POST_REPLY_SUCCESS";
export const POST_REPLY_ERROR = "POST_REPLY_ERROR";

export const GET_REPLIES = "GET_REPLIES";
export const GET_REPLIES_SUCCESS = "GET_REPLIES_SUCCESS";
export const GET_REPLIES_ERROR = "GET_REPLIES_ERROR";

export const GET_TICKET_CATEGORIES = "GET_TICKET_CATEGORIES";
export const GET_TICKET_CATEGORIES_SUCCESS = "GET_TICKET_CATEGORIES_SUCCESS";
export const GET_TICKET_CATEGORIES_ERROR = "GET_TICKET_CATEGORIES_ERROR";